<template>
  <div class="product-container-left" v-loading="loading">
    <div class="contains">
      <vuedraggable class="move-box" ref="move-box" v-bind="subDragOptions('listId')" :list="list"  handle=".task-drag-box" @add="end" @update="end">
        <div class="item bgActive" :class="{'active': currentValue === item.id}" v-for="item in list" :key="item.id" @click="handlerClick(item.id)" :data-id="item.id">
          <!-- 排序按钮 -->
          <div class="task-drag-content">
            <i class="icon iconfont iconicon_drag_order task-drag-box tableIconHover" v-permission="'产品项系列管理-更新系列'" v-if="params === 0"></i>
          </div>
          <!-- 选中图标 -->
          <img v-if="currentValue === item.id" src="image/icon/icon_product_series_pre@2x.png" alt="">
          <span class="radius-box" v-else></span>
          <!-- 标题 -->
          <div class="edit-input title">
            <el-input v-model="item.series_name" maxlength="30" v-if="item.isEdit" ref="input" @blur="changeTitle(item)" @keyup.enter.native="enterTitleChange"></el-input>
            <toolTip v-else :maxWidth="'auto'" :title="item.series_name"><span>{{item.series_name}}</span></toolTip>
          </div>
          <!-- 更多操作 -->
          <el-dropdown @command="handleCommand" v-model="show" size="small" trigger="click" v-if="!item.isEdit" @click.stop v-permission="['产品项系列管理-更新系列', '产品项系列管理-删除系列']">
            <span class="task-sn-hover"  @click.stop>
              <i class="icon iconfont iconicon_user_more_task tableIconHover"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item class="task-drop-item" :command="{ type: 'edit', dataset: item }" v-permission="'产品项系列管理-更新系列'"><i class="icon iconfont iconicon_input"></i>编辑名称</el-dropdown-item>
              <el-dropdown-item class="task-drop-item" :command="{ type: 'del', dataset: item }" v-permission="'产品项系列管理-删除系列'"><i class="icon iconfont iconicon_delete"></i>删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </vuedraggable>
      <nothing v-if="!loading && list.length === 0"></nothing>
    </div>
    <!-- <div class="add-btn" v-permission="'产品项系列管理-新增系列'">
      <wf-button type="primary" plain icon="icon iconfont iconicon_enlarge" size="large" auto @click="showAdd = true">新建系列</wf-button>
    </div> -->
    <AddDialog v-model="showAdd" @success="addSuccess"></AddDialog>
    <DelDialog v-model="delDialogVisible" :id="currentValue" :isSeries="true" title="删除产品系列" @success="delSuccess"></DelDialog>
  </div>
</template>
<script>
import api from '@/services/api/product/product'
import vuedraggable from "vuedraggable"
import AddDialog from './add'
import DelDialog from './detail/components/delDIalog'
import { mapState } from 'vuex';
import bus from '@/bus'
export default {
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    params: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  components: { vuedraggable, AddDialog, DelDialog },
  data() {
    return {
      loading: false,
      list: [],
      show: false,
      oldValue: '',
      showAdd: false,
      delDialogVisible: false
    }
  },
  watch: {
    params: {
      handler() {
        // this.currentValue = ''
        this.init()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState('product/product', {
      state: state => state
    }),
    currentValue: {
      get: function () {
        if (this.value) {
          let item = this.list.find(res => res.id === this.value)
          item ? this.state.series_name = item.series_name : ''
        }
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    },
  },
  created() {
    this.init()
    bus.$on('addSeries', () => {
      this.showAdd = true
    })
  },
  beforeDestroy() {
    bus.$off('addSeries')
  },
  methods: {
    async init() {
      this.loading = true
      let result = await api.productSeriesIndex({page: 1, per_page: 999, development_status: this.params !== 0 ? [this.params] : this.params})
      result.data.map(res => {
        res.isEdit = false
      })
      // this.list && this.list.length === 0 ? this.currentValue = result.data[0]?.id : ''
      if (this.currentValue) {
        let arr = result.data.find(res => res.id === this.currentValue)
        !arr ? this.currentValue = result.data[0]?.id : ''
      }
      !this.currentValue ? this.currentValue = result.data[0]?.id : ''
      this.list = result.data
      this.loading = false
    },
    subDragOptions(key) {
      return {
        animation: 200,
        group: key,
      }
    },
    handleCommand(val) {
      let { type, dataset} = val
      switch (type) {
        case 'edit':
          dataset.isEdit = true
          this.oldValue = dataset.series_name
          this.$nextTick(() => {
            this.$refs?.input[0]?.focus()
          })
          break;
        case 'del':
          dataset.isEdit = false
          this.del(dataset)
          break;
        default:
          break;
      }
    },
    async changeTitle(val) {
      this.$set(val, 'isEdit', false)
      if (this.oldValue !== val.series_name) {
        await api.productSeriesUpdate({ id: val.id, series_name: val.series_name })
        this.$message({
          message: '修改成功',
          type: 'success',
        })
      }
    },
    enterTitleChange() {
      this.$refs?.input[0]?.blur()
    },
    handlerClick(id) {
      this.currentValue = id
    },
    async end(event) {
      let id = event.item.dataset.id * 1;
      let index = this.list.findIndex(res => res.id == id)
      let previous_id = index - 1 < 0 ? 0 : this.list[index - 1].id
      let next_id = (index + 1) > (this.list.length - 1) ? 0 : this.list[index + 1].id
      let params = {
        id,
        previous_id,
        next_id
      }
      console.log(index, this.list, params)
      await api.productSeriesUpdateSort(params).then((res) => {
        this.$message({
          message: '修改成功',
          type: 'success',
        })
      })
    },
    async del(val) {
      if (val.products_count == 0) {
        // await this.$wfAlert('warning', `确认删除${val.series_name}吗?`, '', '删除', 'warning')
        this.delDialogVisible = true
      } else {
        this.$message({
          message: '产品项系列下存在产品项, 不能删除',
          type: 'error',
        })
        return
      }
    },
    async delSuccess(id) {
      await this.init()
      if (id === this.currentValue) {
        this.currentValue = this.list[0].id
      }
    },
    addSuccess() {
      this.$message({
        message: '新增系列成功',
        type: 'success',
      })
      this.showAdd = false
      this.init()
    }
  }
}
</script>
<style lang="scss">
.product-container-left {
  width: 258px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .contains {
    height: 0;
    flex: 1;
    overflow-x: hidden;
    .item {
      height: 48px;
      border-radius: 4px;
      overflow: hidden;
      padding: 0 8px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      display: flex;
      align-items: center;
      transition: all .3s;
      &:hover {
        .task-drag-box {
          visibility: visible;
        }
        .el-dropdown {
          visibility: visible;
        }
      }
      i {
        font-size: 14px;
      }
      .task-drag-content {
        width: 22px;
        height: 25px;
        margin-right: 6px;
      }
      .task-drag-box {
        color: #797979;
        visibility: hidden;
      }
      .el-dropdown {
        visibility: hidden;
      }
      .del {
        margin-left: 8px;
        color: #FF3C3C;
      }
      img {
        width: 18px;
        margin-right: 10px;
      }
      .title {
        width: 0;
        flex: 1;
        color: initial;
        font-size: 14px;
      }
      &.active {
        font-size: 16px;
        background-color: rgba(32, 32, 32, 0.06);
      }
      .radius-box {
        width: 18px;
        height: 18px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        &::after {
          content: '';
          width: 6px;
          height: 6px;
          flex-shrink: 0;
          border-radius: 50%;
          background-color: #A0A0A0;
        }
      }
    }
  }
  .add-btn {
    padding: 24px 0;
    flex-shrink: 0;
  }
}
</style>
